import Add from 'assets/icons/md/md-add.svg'

Add.displayName = 'Add'
export default Add
